import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridViewComponent } from './grid-view/grid-view.component';
import {
  MatCardModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatIconModule
} from '@angular/material';
import { CustomTemplateViewComponent } from './custom-template-view/custom-template-view.component';

@NgModule({
  declarations: [
    GridViewComponent,
    CustomTemplateViewComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatIconModule
  ],
  exports: [
    GridViewComponent,
    CustomTemplateViewComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class GridViewModule { }
